<template>
  <div id="srt_list">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>

    <div id="page-content-wrapper" class="admin-content-area"
         :style="listOnly ? 'padding-top: 0 !important;padding-bottom: 0 !important' : ''">
      <template v-if="cantAccessPage === true">
        <div class="page-name" v-if="!listOnly">
          <div class="page-title"> SRT</div>
          <div class="btn-groups text-right">
            <router-link v-if="addSrt" class="btn btn-primary" v-bind:to="{name: 'SrtCreate'}"><i class="fp-add"> </i>
              Add
            </router-link>
          </div>
        </div>
        <div class="container-fluid" :class="listOnly ? 'no-height-limit' : ''">
          <div class="admin-page-content srt-list">
            <data-table-filter-config :moduleName="'SrtList'" ref="filterSRT"
                                      @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <section class="data-table bg-white">
              <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                 :moduleName="'SrtList'" :position="'top'">
              </custom-pagination>

              <vue-good-table :class="listOnly ? 'table-list-only-height' : ''" ref="listSrtTable" mode="remote"
                              title="SRT" @on-page-change="onPageChange"
                              @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"
                              @on-sort-change="onSortChange" :totalRows="totalRecords" :columns="userColumns"
                              :rows="rows"
                              :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown: dropDownPerPage,
                                    dropdownAllowAll: false,
                                }"
                              :select-options="{
                                    enabled: deleteSrt && !listOnly,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }"
                              :search-options="{
                                enabled: false,
                                }"
              >

                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field == 'action'">
                      <router-link v-if="updateSrt" title="Edit SRT" class="fp-edit mr-3"
                                   v-bind:to="{ name: 'SrtEdit', params: { id: props.row.id } }">
                      </router-link>
                    </div>
                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>
                <div slot="selected-row-actions">
                  <button v-if="deleteSrt" id="deleteSrtBtn" v-on:click.prevent="srtDelete"
                          class="btn btn-danger">Delete
                  </button>
                </div>
              </vue-good-table>
              <custom-pagination v-if="!listOnly" :page-changed="onPageChange" :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer v-if="!listOnly"></app-footer>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "SrtList",
  mixins: [commonMixins, dataTableMixins],
  props: {
    listOnly: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns: [],
    velocity_env: process.env.NODE_ENV,
    columns: [
      {
        label: 'Actions',
        field: 'action',
        sortable: false,
        hidden: true
      },
      {
        label: 'id',
        field: 'id',
        fpFieldType: "text",
        filterable: false,
        hidden: true,
      },
      {
        label: 'Operation code',
        field: 'operation_code',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Operation code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Code Description',
        field: 'falcon_code',
        filterable: true,
        hidden: false,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Falcon Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Hours',
        field: 'hours',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Hours", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Work Description',
        field: 'work_description',
        filterable: true,
        hidden: false,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Work Description", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Additional Information',
        field: 'additional_information',
        filterable: true,
        hidden: false,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Additional Information", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    totalRecords: 0,
    deleteSrt: false,
    updateSrt: false,
    viewSrt: false,
    addSrt: false,
    addClaim: false,
    loading: false,
    selectedFile: "",
    import_error: "",
    duplicatePolicy: []
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'ev_list_srt') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name == 'ev_view_srt') {
            self.viewSrt = true;
          }
          if (permissions[i].name == 'ev_add_srt') {
            self.addSrt = true;
            self.updateSrt = true;
          }
          if (permissions[i].name == 'ev_delete_srt') {
            self.deleteSrt = true;
          }
        }
        if (!self.listOnly && self.updateSrt) {
          self.$nextTick(() => {
            self.columns[0].hidden = false;
          });
        }
      }

    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.startPointValue = self.startingPointArr;
    //self.loadList();
    self.getPermissions();
    if (!self.listOnly) {
      document.title = "SRT | " + process.env.COPYRIGHT_NAME;
    }
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.listSrtTable.unselectAllInternal();
    },

    loadList() {
      var self = this;
      self.loading = true;
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        // messageData: self.message,
        sort: self.serverParams.sort,
        // exportFiltered: self.exportFilteredFlag
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/srt/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {
            self.rows = data.content.row;
            self.totalRecords = data.content.totalRecords;
            self.filteredFlag = false;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          if (jqXHR.status == 0) {
            self.errorMsg = "Remote server cannot be reached";
          } else {
            //redirect to login page if user not authenticated
            if (jqXHR.status == 401) {
              //clear previous data
              localStorage.removeItem("user_obj");
              localStorage.removeItem("tkn");

              self.$router.push("/");
            }
            self.error = jqXHR.responseJSON.message;
          }
        }
      });
    },
    srtDelete() {
      var self = this;
      self.$swal({
        title: 'Are you sure that you want to delete this SRT?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          var data = this.$refs['listSrtTable'].selectedRows;
          var use = [];
          for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listSrtTable'].selectedRows[i].id)
          }
          self.loading = true;
          $("#deleteSrtBtn").val("Deleting ...");
          $.ajax({
            url: process.env.ROOT_API + "/srt/delete",
            type: "POST",
            data: 'id=' + use,
            headers: this.ajxHeaders,
            dataType: 'json',
            success: function (data) {
              self.loading = false;
              setTimeout(function () {
                $(".alert-success").removeClass("show");
                $(".alert-success").addClass("hide");
              }, 10000);
              setTimeout(function () {
                $("#deleteSrtBtn").val("Delete");
              }, 10000);

              var currentlyMapped = data.content.currentlyMappedArr;
              self.notDeletedSwal(currentlyMapped);

              self.loadList();
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR, true, 'srt-delete')
            }
          });

        } else {
          console.log("no");
        }
      });
    },
    notDeletedSwal(currentlyMapped) {
      if (currentlyMapped.length > 0) {
        currentlyMapped = currentlyMapped.toString();
        this.$swal({
          title: 'The following SRT/s could not be deleted, as they are currently in use!',
          text: currentlyMapped,
          type: 'warning',
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonText: 'Close',
        });
      }
    }
  }
};
</script>
<style scoped>


.table-list-only-height {
  height: 50vh;
  overflow: auto;
}

.no-height-limit {
  min-height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SrtList.vue